import { render, staticRenderFns } from "./dicomePage.vue?vue&type=template&id=7294a456&scoped=true"
import script from "./dicomePage.vue?vue&type=script&lang=js"
export * from "./dicomePage.vue?vue&type=script&lang=js"
import style0 from "./dicomePage.vue?vue&type=style&index=0&id=7294a456&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7294a456",
  null
  
)

export default component.exports